import React, { useContext } from 'react';
import { AngularServicesContext } from 'react-app';
import { useSelector } from 'react-redux';
import { getCurrentCourseActiveAICreationCommand } from 'redux/selectors/course';

const CourseContentImage = () => {
  const { isGenerating } = useSelector((state) => state.app.aiCourseCreation);
  const currentAICreationCommand = useSelector(getCurrentCourseActiveAICreationCommand);
  const isAiCreationInProgress = !!currentAICreationCommand && (currentAICreationCommand?.inProgress || isGenerating);


  return (
    <div>
      {!(isAiCreationInProgress) && (
        <div>
          <i className='icon icon-read icon-ultra-large gray-5' />
        </div>
      )}
    </div>
  );
};
export default CourseContentImage;
